import { parseJsonText } from "../jsonText.js";

export const PUBLICATION_FONTS = Object.freeze({
  system: { label: "System Sans", css: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
  inter: { label: "Inter", css: "'Inter', system-ui, sans-serif" },
  "encode-sans": { label: "Encode Sans", css: "'Encode Sans', system-ui, sans-serif" },
  poppins: { label: "Poppins", css: "'Poppins', system-ui, sans-serif" },
  "open-sans": { label: "Open Sans", css: "'Open Sans', system-ui, sans-serif" },
  cheltenham: { label: "Cheltenham", css: "'Cheltenham', Georgia, serif" }
});

export const PUBLICATION_LOCALES = Object.freeze({
  "en-US": "American English",
  "en-GB": "British English"
});

export const FEATURED_TIME_ZONES = Object.freeze([
  "Africa/Johannesburg", "Africa/Gaborone", "Africa/Harare", "Africa/Nairobi", "Africa/Lagos",
  "Europe/London", "America/New_York"
]);

export function validatePublicationFont(value) {
  if (!Object.hasOwn(PUBLICATION_FONTS, value)) throw new Error("Unsupported publication font.");
  return value;
}

export function validatePublicationLocale(value) {
  if (!Object.hasOwn(PUBLICATION_LOCALES, value)) throw new Error("Unsupported editorial language.");
  return value;
}

export function validatePublicationTimeZone(value) {
  if (typeof value !== "string" || !value) throw new Error("Select a valid IANA time zone.");
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: value }).format(new Date(0));
  } catch {
    throw new Error("Select a valid IANA time zone.");
  }
  return value;
}

export function resolvePublicationPreferences(publication, themeFontIdentifier = null) {
  const generalValue = parseJsonText(publication?.settings?.general);
  const general = generalValue && typeof generalValue === "object" ? generalValue : {};
  const selectedFont = general.typography?.fontFamily;
  const fontFamily = Object.hasOwn(PUBLICATION_FONTS, selectedFont)
    ? selectedFont
    : Object.hasOwn(PUBLICATION_FONTS, themeFontIdentifier) ? themeFontIdentifier : "system";
  const locale = Object.hasOwn(PUBLICATION_LOCALES, publication?.defaultLanguage)
    ? publication.defaultLanguage : "en-US";
  let timeZone = "UTC";
  try { timeZone = validatePublicationTimeZone(publication?.timeZone); } catch {}
  return { fontFamily, fontCss: PUBLICATION_FONTS[fontFamily].css, locale, timeZone };
}

export function formatPublicationDate(value, publication, options = {}) {
  const { locale, timeZone } = resolvePublicationPreferences(publication);
  return new Intl.DateTimeFormat(locale, { timeZone, ...options }).format(new Date(value));
}
